/*
 *
 * Do not edit directly
 * Generated on Wed, 16 Jul 2025 15:14:59 GMT
 *
 */


const theme = {
  appearances: {
    bold: {
      description: 'Sets the font weight, to bold on some body text styles. Does not change accessibility properties.',
      type: 'variant',
      values: [ true ]
    },
    colour: {
      type: 'variant',
      values: [
        'default',      'brand',
        'dark',         'light',
        'positive',     'warning',
        'danger',       'black',
        'white',        'brand2',
        'brand3',       'alternative1',
        'alternative2', 'alternative3'
      ]
    },
    compact: {
      description: 'Reduces line height on some body text styles. For data-rich content, not for flow content',
      type: 'variant',
      values: [ true ]
    },
    inverse: {
      description: 'Styles the link white for use on dark backgrounds.',
      type: 'variant',
      values: [ true ]
    },
    size: {
      type: 'variant',
      values: [
        'micro',    'small',
        'medium',   'large',
        'eyebrow',  'h1',
        'h2',       'h3',
        'h4',       'h5',
        'h6',       'display1',
        'display2'
      ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    },
    weight: {
      description: 'Sets the font weight, default is regular 400 weight. Does not change accessibility properties.',
      type: 'variant',
      values: [ 'semibold', 'bold' ]
    }
  },
  rules: [
    {
      if: { weight: 'semibold' },
      tokens: { fontName: 'StagSans', fontWeight: '600' }
    },
    {
      if: { weight: 'bold' },
      tokens: { fontName: 'StagSans', fontWeight: '700' }
    },
    {
      description: 'Please only bold single words while using with headings',
      if: { bold: true },
      tokens: { fontName: 'StagSans', fontWeight: '600' }
    },
    {
      if: { size: 'large' },
      tokens: { fontSize: 20, lineHeight: 1.4 }
    },
    {
      if: { size: 'eyebrow' },
      tokens: {
        color: '#000000',
        fontName: 'StagSans',
        fontSize: 14,
        fontWeight: '600',
        lineHeight: 1.42857142857,
        textTransform: 'uppercase'
      }
    },
    {
      if: { size: 'medium' },
      tokens: { fontSize: 16, lineHeight: 1.5 }
    },
    { if: { compact: true }, tokens: { lineHeight: 1.25 } },
    {
      if: { compact: true, size: 'large' },
      tokens: { lineHeight: 1.2 }
    },
    {
      if: { bold: true, compact: true, size: 'large' },
      tokens: { lineHeight: 1.2 }
    },
    {
      if: { size: 'small' },
      tokens: { fontSize: 14, lineHeight: 1.42857142857 }
    },
    {
      if: { compact: true, size: 'small' },
      tokens: { lineHeight: 1.14285714286 }
    },
    {
      if: { size: 'micro' },
      tokens: { fontSize: 12, lineHeight: 1.33333333333 }
    },
    {
      if: { compact: true, size: 'micro' },
      tokens: { lineHeight: 1.2 }
    },
    {
      if: { bold: true, compact: true, size: 'micro' },
      tokens: { lineHeight: 1.2 }
    },
    {
      if: { size: 'display1' },
      tokens: {
        fontName: 'StagSans',
        fontSize: 44,
        fontWeight: '700',
        lineHeight: 1.22222222222
      }
    },
    {
      if: { size: 'display1', viewport: [ 'lg', 'xl' ] },
      tokens: { fontSize: 70, lineHeight: 1.2 }
    },
    {
      if: { size: 'display2' },
      tokens: {
        fontName: 'StagSans',
        fontSize: 36,
        fontWeight: '700',
        lineHeight: 1.22222222222
      }
    },
    {
      if: { size: 'display2', viewport: [ 'lg', 'xl' ] },
      tokens: { fontSize: 54, lineHeight: 1.14285714286 }
    },
    {
      if: { size: 'h1' },
      tokens: {
        fontName: 'StagSans',
        fontSize: 34,
        fontWeight: '700',
        lineHeight: 1.22222222222
      }
    },
    {
      if: { size: 'h1', viewport: [ 'lg', 'xl' ] },
      tokens: { fontSize: 44, lineHeight: 1.22222222222 }
    },
    {
      if: { size: 'h2' },
      tokens: {
        color: '#000000',
        fontName: 'StagSans',
        fontSize: 32,
        fontWeight: '700',
        lineHeight: 1.25
      }
    },
    {
      if: { size: 'h3' },
      tokens: {
        fontName: 'StagSans',
        fontSize: 24,
        fontWeight: '700',
        lineHeight: 1.33333333333
      }
    },
    {
      if: { size: 'h4' },
      tokens: {
        fontName: 'StagSans',
        fontSize: 20,
        fontWeight: '700',
        lineHeight: 1.2
      }
    },
    {
      if: { size: 'h5' },
      tokens: {
        fontName: 'StagSans',
        fontSize: 18,
        fontWeight: '700',
        lineHeight: 1.22222222222
      }
    },
    {
      if: { size: 'h6' },
      tokens: {
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '700',
        lineHeight: 1.25
      }
    },
    { if: { inverse: true }, tokens: { color: '#ffffff' } },
    { if: { colour: 'default' }, tokens: { color: '#000000' } },
    { if: { colour: 'brand' }, tokens: { color: '#000000' } },
    { if: { colour: 'dark' }, tokens: { color: '#595959' } },
    { if: { colour: 'light' }, tokens: { color: '#666666' } },
    { if: { colour: 'positive' }, tokens: { color: '#1c7b2b' } },
    { if: { colour: 'warning' }, tokens: { color: '#c9370b' } },
    { if: { colour: 'danger' }, tokens: { color: '#c9370b' } },
    { if: { colour: 'black' }, tokens: { color: '#000000' } },
    { if: { colour: 'white' }, tokens: { color: '#ffffff' } },
    { if: { colour: 'brand2' }, tokens: { color: '#7a3dfc' } },
    { if: { colour: 'brand3' }, tokens: { color: '#5b2bc2' } },
    { if: { colour: 'alternative1' }, tokens: { color: '#404040' } },
    { if: { colour: 'alternative2' }, tokens: { color: '#ff0076' } },
    { if: { colour: 'alternative3' }, tokens: { color: '#dd0066' } }
  ],
  tokens: {
    color: '#000000',
    fontName: 'StagSans',
    fontScaleCap: 64,
    fontSize: 16,
    fontWeight: '400',
    gradient: null,
    letterSpacing: 0,
    lineHeight: 1.5,
    superScriptFontSize: null,
    textTransform: 'none'
  }
}
export default theme
